export enum TemplateTypes {
    SignRequest = 1,
    CustomDocFile = 2,
}
